<template>
    <div>
        <v-container>
            <v-card>        
                <v-card-text>
                    <v-row v-if="!vendor">
                        <v-col cols="3" class="yellow lighten-4 font-weight-bold">Upload File Penjelasan</v-col>              
                        <v-col cols="6" >
                            <v-file-input
                                label="File Penjelasan"
                                v-model="formFileUpload.uploadFilePenjelasan"
                                :placeholder="formFileUpload.filePenjelasan" 
                                accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" 
                                append-icon="get_app" 
                                @click:append="tenderLib.getFileDownloadLink(formFileUpload.paketPenyediaId, `FileJadwalPrivate_${formFileUpload.urut}`, formFileUpload.filePenjelasan, false)" 
                            >
                            </v-file-input>
                        </v-col>
                        <v-col cols="3" >
                            <v-btn color="green"  @click="submitFormFileUpload()">Upload</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="vendor ">
                        <v-col cols="3" class="yellow lighten-4 font-weight-bold">File Penjelasan</v-col>
                        <v-col v-if="formFileUpload.filePenjelasan !== ''">
                            <v-btn icon @click="tenderLib.getFileDownloadLink(formFileUpload.paketPenyediaId, `FileJadwalPrivate_${formFileUpload.urut}`, formFileUpload.filePenjelasan, false)"><v-icon color="green">get_app</v-icon></v-btn>
                            {{ formFileUpload.filePenjelasan }}
                        </v-col>
                        <v-col v-else>
                            Admin belum upload file penjelasan.
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row v-if="!vendor">
                <v-col cols="2">
                    <v-btn class="blue" dark @click="getData()">Refresh</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="!readonly && vendor">
                <v-col> <v-btn color="teal darken-2" dark @click="openFormTopic(null)">Buat Pertanyaan</v-btn> </v-col>
            </v-row>
            <v-row v-for="(topic, i) in listTopic" :key="'topic_' + i">
                <v-col>
                    <v-card>
                        <v-card-actions v-if="!readonly && vendor && (userId ===  topic.chat.creatorUserId)"><v-btn class="teal" @click="openFormTopic(topic)" dark>Edit</v-btn></v-card-actions>
                        <v-card-title>{{ topic.chat.subject }}</v-card-title>
                        <v-card-subtitle>
                            <span class="blue--text"> {{ topic.chat.creatorUserId }} </span> 
                            <span> [{{ getDateTimeFormatted(topic.chat.updatedAt) }}] </span>
                            <v-textarea :value="topic.chat.message" row-height="4" outlined filled readonly auto-grow />
                        </v-card-subtitle>
                        <v-list-item three-line v-for="(message, j) in topic.messages" :key="'message_' + j">
                            <v-list-item-content>
                                <v-list-item-subtitle>
                                    <span class="blue--text"> {{ message.senderUserId }} </span> 
                                    <span> [{{ getDateTimeFormatted(message.updatedAt) }}] </span>
                                    <v-textarea :value="message.message" row-height="4" outlined filled readonly auto-grow></v-textarea>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-card-actions v-if="!readonly">
                            <v-container>
                                <v-row> <v-text-field v-model="topic.send" placeholder="Kirim pesan..." outlined /> </v-row>
                                <v-row> 
                                    <v-col cols="2">
                                        <v-btn class="green" dark @click="submitSendMessage(topic)">Kirim Pesan</v-btn> 
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn class="blue" dark @click="getData()">Refresh</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- DIALOG - CHAT -->
        <v-dialog v-model="formTopic.isShowing" max-width="400px" persistent>
            <v-form ref="formTopic" v-model="formTopic.isValid" lazy-validation>
                <v-card>
                    <v-container>
                        <v-row>
                            <v-col> <v-text-field v-model="formTopic.subject" label="Topik" outlined /> </v-col>
                        </v-row>
                        <v-row>
                            <v-col> <v-textarea v-model="formTopic.message" label="Pertanyaan" outlined /> </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-btn color="green" @click="submitFormTopic()">Simpan</v-btn>
                        <v-btn color="cyan" @click="closeFormTopic()">Batal</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- Notification -->
        <v-snackbar
            v-model="notification.show"
            :color="notification.color"
            :top="true"
            :right="true"
            :timeout=3000
        >
            {{notification.text}}
        </v-snackbar>

    </div>
</template>


<script>

const API_URL = process.env.VUE_APP_ROOT_API
import { format, parseISO } from 'date-fns';
const axios = require('axios').default;
import { TenderLib } from "./../../lib/tenderLib";

export default {
    props: {
        tahap: {
            type: String,
            default: "P"
        },
        readonly: {
            type: Boolean,
            default: false
        },
        vendor: {
            type: Boolean,
            default: false
        },
        urut: {
            type: Number,
            default: 0
        },
        tipe: {
            type: String,
            default: "P"
        },
    },

    data() {
        return {
            // Example
            /*
            listTopic: [
                {
                    chat: {
                        id: 1,
                        creatorUserId: "Operator ULP 01",
                        subject: "Penjelasan mengenai kualifikasi tender",
                        message: "Para peserta boleh memberikan pertanyaan seputar kualifikasi tender",
                        updatedAt: "2020-05-25 08:30:00"
                    },
                    messages: [
                        {
                            id: 1,
                            senderUserId: "Peserta 01",
                            message: "Blablabla dari Peserta 01 asdfasdfasdfsadf",
                            updatedAt: "2020-05-25 18:30:00"
                        },
                        {
                            id: 2,
                            senderUserId: "Peserta 02",
                            message: "Blablabla dari Peserta 02 dadfasdfasdfasdfsadfsdf asdfasdfasdfasdfasdf", 
                            updatedAt: "2020-05-25 20:30:00"
                        },
                        {
                            id: 3,
                            senderUserId: "Peserta 03",
                            message: "Blablabla dari Peserta 03 a dari Peserta 02 dadfasdfasdfasdfsadfsdf",
                            updatedAt: "2020-05-26 08:30:00"
                        },
                        {
                            id: 4,
                            senderUserId: "Peserta 04",
                            message: "Blablabla dari Peserta 04  ablabla dari Peserta 03 a dari Pe",
                            updatedAt: "2020-05-26 12:30:00"
                        },
                    ]
                },
                {
                    chat: {
                        id: 2,
                        creatorUserId: "Operator ULP 01",
                        subject: "Penjelasan mengenai APA AJA tender",
                        message: "Para peserta boleh memberikan pertanyaan seputar kualifikasi tender",
                        updatedAt: "2020-05-25 08:30:00"
                    },
                    messages: [
                        {
                            id: 5,
                            senderUserId: "Peserta 01",
                            message: "Blablabla dari Peserta 01 asdfasdfasdfsadf",
                            updatedAt: "2020-05-25 18:30:00"
                        },
                        {
                            id: 6,
                            senderUserId: "Peserta 02",
                            message: "Blablabla dari Peserta 02 dadfasdfasdfasdfsadfsdf asdfasdfasdfasdfasdf", 
                            updatedAt: "2020-05-25 20:30:00"
                        },
                        {
                            id: 7,
                            senderUserId: "Peserta 03",
                            message: "Blablabla dari Peserta 03 a dari Peserta 02 dadfasdfasdfasdfsadfsdf",
                            updatedAt: "2020-05-26 08:30:00"
                        },
                        {
                            id: 8,
                            senderUserId: "Peserta 04",
                            message: "Blablabla dari Peserta 04  ablabla dari Peserta 03 a dari PeBlablabla dari Peserta 02 dadfasdfasdfasdfsadfsdf asdfasdfasdfasdfasdfBlablabla dari Peserta 02 dadfasdfasdfasdfsadfsdf asdfasdfasdfasdfasdf",
                            updatedAt: "2020-05-26 12:30:00"
                        },
                    ]
                }
            ],
            */
            listTopic: [],

            formTopic: {
                chatId: null,
                subject: "",
                message: "",
                isShowing: false,
                isEditing: false,
                isDeleting: false,
                isValid: false,
                everOpened: false,
            },
            formFileUpload: {
                paketPenyediaId: null,
                paket: {
                    kode: null,
                    nama: null,
                    metodePemilihan: null,
                },
                urut: null,
                uploadFilePenjelasan: null,
                filePenjelasan: null,
                showVendor: 0
            },

            notification: {
                show: false,
                color: "success",
                text: ""
            },
            serverTime: "",
            jadwalView: "",
            kunciProses: false,
            tenderLib: TenderLib
        }
    },

    computed: {
        userId: function() {
            return this.$store.getters['userInfo'].userId;
        },
        paket: function() {
            return this.$store.getters['lelang/paket'];
        },
        jadwal: function() {
        return this.$store.getters['lelang/jadwal']
        },
    },

    watch: {
        paket() {
            this.getData();
        }
    },

    mounted() {
        this.getData();
    },

    methods: {

        getDateTimeFormatted(dateTime) {
            return dateTime ? format(Date.parse(dateTime), "dd-MM-yyyy HH:mm") : ""
        },

        getDateFormattedDatefnsMinute: function(date) {
            return date ? format(parseISO(date), "dd MMM yyyy HH:mm") : '';
        },

        getData() {
            let jadwalUrut = this.jadwal.find(el => el.urut == this.urut);
            this.formFileUpload.paket.id = this.paket.id;
            this.formFileUpload.paket.kode = this.paket.kode;
            this.formFileUpload.paket.nama = this.paket.nama;
            this.formFileUpload.paket.metodePemilihan = this.paket.metodePemilihan;
            this.formFileUpload.paketPenyediaId = this.paket.id;
            this.formFileUpload.urut = this.urut;
            this.formFileUpload.filePenjelasan = jadwalUrut.fileJadwalPrivate;
            console.log("ChatMessage:getData", this.paket.id, "-", this.tahap);
            
            this.listTopic = [];
            
            axios.get(`${API_URL}/api/tender/chat/message/paket/${this.paket.id}/${this.tahap}`)
            .then( (response) => {
                response.data.forEach(element => {
                    const topic = {
                        chat: element.chat,
                        messages: element.messages,
                        send: ""
                    };

                    this.listTopic.push(topic);
                });

                //console.log("Chat mounted list topic: ", this.listTopic);
            })
            .catch( (error) => {
                console.error(error);
            });
        },

        resetFormTopic() {
            this.formTopic.chatId = null;
            this.formTopic.subject = "";
            this.formTopic.message = "";
            if (this.formTopic.everOpened) this.$refs.formTopic.reset();
        },

        closeFormTopic() {
            this.resetFormTopic();
            this.formTopic.isShowing = false;
            this.formTopic.isEditing = false;
            this.formTopic.isDeleting = false;
        },

        openFormTopic(topic) {
            this.resetFormTopic();
            this.formTopic.isShowing = true;

            if (topic) {
                this.formTopic.chatId = topic.chat.id;
                this.formTopic.subject = topic.chat.subject;
                this.formTopic.message = topic.chat.message;
                this.formTopic.isEditing = true;
            }

            this.formTopic.everOpened = true;
        },

        submitFormTopic() {
            if (this.paket.id == null) {
                console.error("Fail to submit form topic. paketId is NULL!"); 
                return;
            }

            if (!this.$refs.formTopic.validate()) return;

            let data = {
                paketPenyediaId: Number(this.paket.id),
                tahap: this.tahap,
                creatorUserId: this.userId,
                subject: this.formTopic.subject,
                message: this.formTopic.message
            };

            // Update
            if (this.formTopic.isEditing) {
                console.log("Chat UPDATE: ", data);

                axios.put(`${API_URL}/api/tender/chat/${this.formTopic.chatId}`, data)
                .then( (response) => {

                    const index = this.listTopic.findIndex(element => { return element.chat.id === response.data.id; });
                    if (index != -1) {
                        this.listTopic[index].chat = response.data;
                    }

                    this.notification = {
                        show: true,
                        color: "success",
                        text: "Topik berhasil diperbarui"
                    };

                })
                .catch( (error) => {
                    console.error(error);
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal update topik [${error.message}]`
                    };
                });
            } 
            // Create
            else {
                console.log("Chat CREATE: ", data);

                axios.post(`${API_URL}/api/tender/chat`, data)
                .then( (response) => {
                    console.log("Chat create response: ", response.data);

                    const topic = {
                        chat: {
                            id: response.data.id,
                            creatorUserId: response.data.creatorUserId,
                            subject: response.data.subject,
                            message: response.data.message,
                            updatedAt: response.data.updatedAt
                        },
                        messages: [],
                        send: "",
                    };

                    this.listTopic.push(topic);

                    this.notification = {
                        show: true,
                        color: "success",
                        text: "Topik baru berhasil dibuat"
                    };

                })
                .catch( (error) => {
                    console.error(error);
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal membuat topik [${error.message}]`
                    };
                });
            }

            this.closeFormTopic();
        },

        submitSendMessage(topic) {
            if (topic == null) return;
            
            const data = {
                chatId: topic.chat.id,
                senderUserId: this.userId,
                message: topic.send
            };

            axios.post(`${API_URL}/api/tender/chat/message`, data)
            .then( (response) => {
                const newMessage = {
                    id: response.data.id,
                    senderUserId: response.data.senderUserId,
                    message: response.data.message,
                    updatedAt: response.data.updatedAt 
                };

                const index = this.listTopic.findIndex(element => { return element.chat.id === response.data.chatId; });
                if (index != -1) {
                    this.listTopic[index].messages.push(newMessage);
                    this.listTopic[index].send = "";
                }

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Pesan telah terkirim"
                };

            })
            .catch( (error) => {
                console.error(error);
            });
        },

        submitFormFileUpload() {
            let fdata = new FormData()
            fdata.append('paketPenyediaId', this.paket.id)
            fdata.append('paket', JSON.stringify(this.formFileUpload.paket))
            fdata.append('urut', this.formFileUpload.urut)
            fdata.append('tipe', this.tipe)
            fdata.append('showVendor', this.formFileUpload.showVendor)
            fdata.append('userId', this.$store.getters['userInfo'].userId)
            
            if (this.formFileUpload.uploadFilePenjelasan) fdata.append('file', this.formFileUpload.uploadFilePenjelasan)
            axios.post(API_URL+"/api/rup/jadwal-private/upload", fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
              .then( (response) => {
                this.formFileUpload.filePenjelasan = response.data[0].fileJadwalPrivate;
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Sukses upload file penjelasan"
                };
              })
              .catch( (error) => {
                  this.notification = {
                      show: true,
                      color: "error",
                      text: `[${error.message}] Gagal upload`
                  }
              });
        }

    } // methods
}

</script>


<style scoped>
.v-textarea {
    font-size: 1.0em;
}
</style>
